<template>
  <w-sliding-popup ref="workDetailPopup" :type="popupType" title="작업목록" width="600px" @close="onClose">
    <!-- 190709 sliding-task 클라스 추가 -->
    <div slot="content" class="sliding-task">
      <el-row type="flex" justify="end">
        <w-header-search-button @click="showSearchHeader" align="right" class="mr-b10" />
      </el-row>
      <el-table-wrapper
        ref="WorkListExpandTable"
        class="expandable-table c-pointer"
        :data="workList"
        style="width: 100%"
        @cell-click="rowClicked"
        @expand-change="expandEvent"
        :show-custom-header="true"
        :show-search-tool="searchFlag"
        :pagination="false"
        remote
        :column-default="columnDefault"
        :columns="tableColumn"
        @condition-change="setTableParameter"
      >
        <template #expand-col="scope">
          <!-- 190709 작업처리 steps 방식 변경 -->
          <div class="task-steps">
            <li :class="[isActive(workLastStatus, 1), 'step-register']">작업등록</li>
            <!-- 현재 진행중인 li에 active 클라스 추가 -->
            <li :class="[isActive(workLastStatus, 2), 'step-processing']">처리중</li>
            <li :class="[isActive(workLastStatus, 3), 'step-complete']">작업완료</li>
          </div>
          <w-work-extend-page class="mr-b10" :form-datas="scope.row" :workLastStatus="workLastStatus" />
        </template>
        <template #status-slot="scope">
          <span v-if="scope.row['VVM_RUNNINGSTATUS/ALIVE'] === 1"><span class="state on"></span>켜짐</span>
          <span v-else><span class="state off"></span>꺼짐</span>
        </template>
      </el-table-wrapper>
      <el-row class="mr-t10" type="flex" justify="center">
        <el-pagination @current-change="handleCurrentChange" background :current-page.sync="currentPage" :page-sizes="[5]" :page-size="5" layout="total, sizes, prev, pager, next" :total="total"> </el-pagination>
      </el-row>
    </div>
  </w-sliding-popup>
</template>

<script>
import { columnDefault } from '@/constants/table';
import perfAPI from '@/api/performance/root';
import workManageAPI from '@/api/work/work';
import { isEmpty, forEach, head } from 'lodash';
import WWorkExtendPage from '@/views/performance/root/components/popup/components/WorkExtendPage';

export default {
  name: 'WWorkDetailPopup',
  data() {
    return {
      workLastStatus: null,
      workProcessTableDatas: [],
      searchParams: [],
      searchFlag: false,
      total: 0,
      currentPage: 1,
      columnDefault,
      activeName: null,
      workList: [],
      isExpand: true,
      lastCalledRow: null,
      tableColumn: [{ align: 'center', type: 'expand', scopedSlot: 'expand-col', formatter: this.getTableValueAfterCheckEmpty }, { label: '작업명', prop: 'workName', searchable: true }, { label: '작업 시간', width: 300, prop: 'workTimeRange' }],
      popupType: 'common', // default
    };
  },
  components: {
    WWorkExtendPage,
  },
  computed: {
    showSettingView() {
      return this.$store.state.common.showSettingView;
    },
    visible() {
      return this.$store.state.popup.showWorkDetailPopup;
    },
    param() {
      return this.$store.state.popup.workDetailPopupParams;
    },
  },
  watch: {
    visible: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
  beforeDestroy() {
    if (this.visible) {
      this.close();
    }
  },
  methods: {
    isActive(workStatus, step) {
      return this.moveActiveTab(workStatus) === step ? 'active' : '';
    },
    /**
     * 헤더 검색 설정
     * @author leesy918
     * @param  {[type]} value [description]
     */
    setTableParameter(value) {
      this.searchParams = value.searchParams;
      this.param.searchParams = this.searchParams;
      this.loadData(this.param);
    },
    showSearchHeader() {
      this.searchFlag = !this.searchFlag;
    },
    /**
     * 커스텀 페이징 처리
     * @author leesy918
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadData(this.param);
    },
    open() {
      this.clearData();
      this.$refs.workDetailPopup.open();
      this.popupType = this.showSettingView ? 'setting' : 'common';
      this.$nextTick(() => {
        this.loadData(this.param);
      });
    },
    close() {
      this.$refs.workDetailPopup.close();
    },
    onClose() {
      this.workLastStatus = null;
      this.$refs.WorkListExpandTable.clearFilter();
      this.searchFlag = false;
      this.$store.dispatch('closeWorkDetailPopup');
    },
    /**
     * 데이터 초기화
     * @author leesy918
     * @return {[type]} [description]
     */
    clearData() {
      this.workList = [];
      this.lastCalledRow = null;
      this.currentPage = 1;
    },
    /**
     * 테이블 확장 이벤트
     * @author leesy918
     * @param  {[type]} row          [description]
     * @param  {[type]} expandedRows [description]
     * @return {[type]}              [description]
     */
    expandEvent(row, expandedRows) {
      this.$nextTick(() => {
        const rows = this.$refs.WorkListExpandTable.$children[0].bodyWrapper.getElementsByClassName('el-table__row');

        forEach(rows, (item) => {
          const cells = item.getElementsByTagName('td');
          forEach(cells, (cell) => {
            if (item.className !== 'el-table__row expanded') {
              cell.style = 'border-bottom: 1px solid #f1f2f5 !important;';
            } else {
              cell.style = 'border-bottom: 1px solid #5a7aa1 !important;';
            }
          });
        });
      });
      this.isExpand = !isEmpty(expandedRows);
      let oldRow = {};
      expandedRows.map((value) => {
        if (value.workSeqNumber !== row.workSeqNumber) {
          oldRow = value;
        }
        return null;
      });

      // 펼쳐진 row가 2개일 경우에는 최근에 클릭한 row 외에는 다시 닫아주어야한다.
      if (expandedRows.length > 1) {
        this.lastCalledRow = row;
      }
      if (oldRow.workSeqNumber && this.lastCalledRow.workSeqNumber !== oldRow.workSeqNumber) {
        this.$refs.WorkListExpandTable.$children[0].toggleRowExpansion(oldRow);
      }
    },
    rowClicked(row) {
      this.loadWorkHist(row);
      this.$refs.WorkListExpandTable.$children[0].toggleRowExpansion(row);
    },
    /**
     * 확장된 작업의 처리내역을 조회한다.
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    loadWorkHist(row) {
      const params = {
        workSeqNumber: row.workSeqNumber,
      };
      workManageAPI.getWorkProcessHistList(params).then((result) => {
        if (result.data.success === true) {
          this.workProcessTableDatas = result.data.data;
          this.workLastStatus = head(result.data.data).workStatus;
          this.moveActiveTab(this.workLastStatus);
        }
      });
    },
    loadData(param) {
      param.start = 5 * (this.currentPage - 1);
      param.limit = 5;
      perfAPI.getSelectedDateWorkList(param).then((response) => {
        if (response.data.success) {
          this.workList = response.data.data;
          if (!isEmpty(this.workList)) {
            this.lastCalledRow = this.workList[0];
            this.loadWorkHist(this.lastCalledRow);
            this.activeName = this.lastCalledRow.workSeqNumber;
            this.total = response.data.total;
            this.$nextTick(() => {
              this.$refs.WorkListExpandTable.$children[0].toggleRowExpansion(this.lastCalledRow);
            });
          }
        }
      });
    },
    /**
     * 작업 일정 탭 이동
     * @author leesy918
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    moveActiveTab(value) {
      switch (value) {
        case 'A':
          return 1;
        case 'P':
          return 2;
        case 'F':
        case 'S':
          return 3;
        default:
          return 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-off {
  .ll-table-container {
    .el-table {
      border-top: 2px solid #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/WorkDetailPopup/index.vue